import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { Location } from "../types";

interface LocationFilterProps {
  locations: Location[];
  selectedLocation: number | undefined;
  onChange: (locationId: number | undefined) => void;
}

const LocationFilter: React.FC<LocationFilterProps> = ({
  locations,
  selectedLocation,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onChange(value ? parseInt(value) : undefined);
  };

  return (
    <Box mb={4}>
      <Box mb={2}>
        <Text fontWeight="medium" mb={1}>
          Select Location
        </Text>
        <select
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "6px",
            borderWidth: "1px",
            borderColor: "#e2e8f0",
            backgroundColor: "white",
          }}
          value={selectedLocation || ""}
          onChange={handleChange}
        >
          <option value="">All Locations</option>
          {locations.map((location) => (
            <option key={location.id} value={location.id}>
              {location.name}
            </option>
          ))}
        </select>
      </Box>
    </Box>
  );
};

export default LocationFilter;
